<template>
  <div>
    <ProgramCardModal
      :programArticle="selectedProgramArticle"
      @close="clearSelectedArticle"
      :isWorkshop="true"
      :userLoggedIn="userLoggedIn"
      :workshopRegistrationOpened="workshopRegistrationOpened"
      @registerWorkshop="registerWorkshop"
      @unRegisterWorkshop="unRegisterWorkshop"
      :scrollToSection="scrollToSection"
      :workshop-registration-state="workshopRegistrationStateMutable"
      :max-workshop-registrations-per-user="maxWorkshopRegistrationsPerUser"
    />
    <div class="md:flex hidden flex-col mt-[100px] gap-[60px] lg:mx-[160px] mx-[20px]" ref="scrollContainer">
      <div class="flex flex-row items-center gap-4">
        <p class="text-black lg:text-[56px] text-[28px] font-extrabold">Workshopy</p>
        <button @click="scrollToTheStart" class="bg-white shadow-lg text-center rounded-full w-[52px] h-[52px] items-center justify-center">
          <svg class="justify-self-center ml-[-4px]" xmlns="http://www.w3.org/2000/svg" width="35" height="34" viewBox="0 0 35 34" fill="none">
            <path d="M21.6592 25.1387L13.3359 16.8154L21.6592 8.49219" stroke="#666666" stroke-width="2.77997" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="bg-white shadow-lg text-center rounded-full w-[52px] h-[52px] items-center justify-center" @click="scrollToTheEnd">
          <svg class="justify-self-center" xmlns="http://www.w3.org/2000/svg" width="35" height="34" viewBox="0 0 35 34" fill="none">
            <path d="M13.3408 8.49411L21.6641 16.8174L13.3408 25.1406" stroke="#666666" stroke-width="2.77997" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="relative">
        <Transition name="fadeRight">
          <div v-if="!scrolledToRight" class="md:block hidden absolute md:w-32 right-[-1px] z-10 md:h-full" style="background: linear-gradient(to right, rgba(248,249,250, 0), rgba(248,249,250, 0.8) 70%, rgba(248,249,251) 100%);"></div>
        </Transition>
        <Transition name="fadeLeft">
          <div v-if="scrolledToRight" class="left-[-1px] md:block hidden absolute md:w-32 z-20 md:h-full" style="background: linear-gradient(to left, rgba(248,249,250, 0), rgba(248,249,250, 0.8) 70%, rgba(248,249,251) 100%);"></div>
        </Transition>
      <div class="grid gap-[20px] overflow-hidden"
           ref="workshops"
           :style="'grid-template-columns: repeat('+ Object.keys(workshopsGroupedByHall).length +', minmax(auto, 1fr)); }'">
          <div class="ml-1"
          :key="key"
          v-for="(group, key, index) in workshopsGroupedByHall"
        >
          <div class="mb-5">
            <h2 class="font-semibold text-[24px]" :class="[index%2 === 0? 'text-brand-orange' : 'text-brand-blue']">
            </h2>
          </div>
          <p class="font-semibold text-[24px] mb-[30px]" style="line-height: 24px;"
             :class="[index%2 === 0 ? 'text-brand-orange' : 'text-brand-blue']">
            {{ workshopHallMap[key] }}
          </p>
          <WorkshopCard
            v-for="(workshop, j) in group"
            :key="j"
            class="my-2"
            :programArticle="workshop"
            :highlightColor="index%2===0 ? 'orange' : 'blue'"
            @clicked="selectProgramArticle"
            @registerWorkshop="registerWorkshop"
            @unRegisterWorkshop="unRegisterWorkshop"
            :isWorkshop="true"
            :userLoggedIn="userLoggedIn"
            :registerGroupsCheck="registerGroupsCheck[key]"
            :workshopRegistrationState="workshopRegistrationStateMutable"
            :maxWorkshopRegistrationsPerUser="maxWorkshopRegistrationsPerUser"
            :workshopRegistrationOpened="workshopRegistrationOpened"
            :workshopsGroupedByTime="workshopsGroupedByTime"
          />
        </div>
      </div>
      </div>

    </div>
    <div class="relative mx-[20px] md:hidden flex flex-col mt-[80px]">

      <div class="absolute w-full h-full opacity-40 bg-brand-orange z-[-1]" style="filter: blur(150px)"></div>
      <p class="text-center text-brand-gray-900 text-[28px] mb-[34px] font-extrabold justify-self-center" style="line-height: normal">Workshopy</p>
      <div class="mb-[30px] transition-all w-full h-full shadow-lg" style="overflow: hidden; border-radius: 15px; outline: white solid; outline-offset: -2px; justify-content: center; align-items: center; display: inline-flex">
        <div @click="selectPage(0)" class="transition-all px-[20px] py-[8px] min-h-[40px] bg-white" style="flex: 1 1 0; justify-content: center; align-items: center; gap: 8px; display: flex">
          <div :class="selected === 0 ? 'text-brand-orange' : 'text-gray-600'" class="whitespace-nowrap" style="font-size: 24px;font-weight: 600; line-height: 32px; ">{{selected === 0 ? selectedPages[0] : nonSelectedPages[0]}}</div>
        </div>
        <div class="w-[1px] h-[36px] relative bg-gray-300 rounded-[1px]"></div>
        <div @click="selectPage(1)" class="transition-all px-[20px] py-[8px] min-h-[40px] bg-white" style="flex: 1 1 0; justify-content: center; align-items: center; gap: 8px; display: flex">
          <div :class="selected === 1 ? 'text-brand-orange' : 'text-gray-600'" class="whitespace-nowrap" style="font-size: 24px;font-weight: 600; line-height: 32px; ">{{selected === 1 ? selectedPages[1] : nonSelectedPages[1]}}</div>
        </div>
        <div class="w-[1px] h-[36px] relative bg-gray-300 rounded-[1px]"></div>
        <div @click="selectPage(2)" class="transition-all px-[20px] py-[8px] min-h-[40px] bg-white"  style="flex: 1 1 0; justify-content: center; align-items: center; gap: 8px; display: flex">
          <div :class="selected === 2 ? 'text-brand-orange' : 'text-gray-600'" class="whitespace-nowrap" style="font-size: 24px; font-weight: 600; line-height: 32px; ">{{selected === 2 ? selectedPages[2] : nonSelectedPages[2]}}</div>
        </div>
        <div class="w-[1px] h-[36px] relative bg-gray-300 rounded-[1px]"></div>
        <div @click="selectPage(3)" class="transition-all px-[20px] py-[8px] min-h-[40px] bg-white"  style="flex: 1 1 0; border-top-right-radius: 15px; border-bottom-right-radius: 15px; justify-content: center; align-items: center; gap: 8px; display: flex">
          <div :class="selected === 3 ? 'text-brand-orange' : 'text-gray-600'" class="whitespace-nowrap" style="font-size: 24px; font-weight: 600; line-height: 32px;">{{selected === 3 ? selectedPages[3] : nonSelectedPages[3]}}</div>
        </div>
      </div>
      <div class="relative w-full mx-auto">
        <div class="overflow-hidden relative"
             :style="{height: getMaxCapacityInLargestHall*180 + 'px'}">
          <div
            class="absolute inset-0 transition-transform duration-300 ease-in-out"
            :class="{
          'translate-x-0 z-10 opacity-100': index === selected,
          'translate-x-full': index > selected,
          '-translate-x-full': index < selected
        }"
            :key="key"
            v-for="(group, key, index) in workshopsGroupedByHall"
          >
          <WorkshopCardMobile
            v-for="(workshop, j) in group"
            :key="j"
            class="my-2"
            :programArticle="workshop"
            :highlightColor="'orange'"
            @clicked="selectProgramArticle"
            @registerWorkshop="registerWorkshop"
            @unRegisterWorkshop="unRegisterWorkshop"
            :isWorkshop="true"
            :userLoggedIn="userLoggedIn"
            :registerGroupsCheck="registerGroupsCheck[key]"
            :workshopRegistrationState="workshopRegistrationStateMutable"
            :maxWorkshopRegistrationsPerUser="maxWorkshopRegistrationsPerUser"
            :workshopRegistrationOpened="workshopRegistrationOpened"
            :workshopsGroupedByTime="workshopsGroupedByTime"
          />
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from "../Carousel/Carousel.vue";
import ProgramCard from "../Program/ProgramCard.vue";
import ProgramCardModal from "../Program/ProgramCardModal.vue";
import axios from "axios";
import {parse} from 'date-fns';
import WorkshopCard from "./WorkshopCard.vue";
import WorkshopCardMobile from "./WorkshopCardMobile.vue";

export default {
  components: {
    WorkshopCardMobile,
    WorkshopCard,
    Carousel,
    ProgramCard,
    ProgramCardModal,
  },

  props: {
    programEvents: {
      type: Array,
      default: () => [],
    },

    userLoggedIn: {
      type: Boolean,
      default: false,
    },

    workshopRegistrationState: {
      type: Object,
      default: () => {
      },
    },

    maxWorkshopRegistrationsPerUser: {
      type: Number,
    },

    maxRegistrationsPerWorkshop: {
      type: Number,
      default: 28
    },

    workshopRegistrationOpened: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedProgramArticle: null,
      workshopRegistrationStateMutable: this.workshopRegistrationState,
      registerGroupsCheck: {},
      scrollToSection: false,
      offsetLeft: '0px',
      selectedPages: ['Workshopy 1', 'Workshopy 2', 'Workshopy 3', 'Workshopy 4'],
      nonSelectedPages: ['1', '2', '3', '4'],
      selected: 0,
      scrolledToRight: false,
      workshopHallMap: {
        ['workshop1']: 'Workshopy 1',
        ['workshop2']: 'Workshopy 2',
        ['workshop3']: 'Workshopy 3',
        ['workshop4']: 'Workshopy 4',
        ['workshop5']: 'Workshopy 5',
      },
    };
  },

  watch: {
    workshopRegistrationStateMutable: {
      handler() {
        let times = Object.keys(this.workshopsGroupedByTime);
        times.forEach(startTime => {
          this.registerGroupsCheck[startTime] = this.userHasWorkshopRegisteredForGivenTimeSlot(startTime);
        })
      },
      immediate: true
    }
  },

  computed: {
    getMaxCapacityInLargestHall() {
      const grouped = this.workshopsGroupedByHall

      let maxTotalCapacity = 0;

      for (const hall in grouped) {
        const workshops = grouped[hall];
        if (workshops.length > maxTotalCapacity) {
          maxTotalCapacity = workshops.length;
        }
      }

      return maxTotalCapacity;
    },
    workshopsGroupedByTime() {
      const workshops = this.programEvents.filter(
        (event) => event.type === "workshop"
      );

      const grouped = workshops.reduce((groupedWorkshops, workshop) => {

        let parsedWorkshopEnd = parse(workshop.end, "HH:mm", new Date());

        if (groupedWorkshops[parsedWorkshopEnd] == null) {
          groupedWorkshops[parsedWorkshopEnd] = []
        }

        let capacity = this.maxRegistrationsPerWorkshop;

        if (this.workshopRegistrationStateMutable.workshop_registrations[workshop.id]) {
          capacity -= this.workshopRegistrationStateMutable.workshop_registrations[workshop.id].count;
        }

        groupedWorkshops[parsedWorkshopEnd].push({...workshop, capacity: capacity});

        return groupedWorkshops;
      }, {});

      return Object.keys(grouped)
        .sort()
        .reduce((a, c) => ((a[c] = grouped[c]), a), {});
    },
    workshopsGroupedByHall() {
      const workshops = this.programEvents.filter(
        (event) => event.type === "workshop" && ['workshop1', 'workshop2', 'workshop3', 'workshop4'].includes(event.hall)
      );

      const grouped = workshops.reduce((groupedWorkshops, workshop) => {

        const parsedWorkshopHall = workshop.hall;

        if (groupedWorkshops[parsedWorkshopHall] == null) {
          groupedWorkshops[parsedWorkshopHall] = []
        }

        let capacity = this.maxRegistrationsPerWorkshop;

        if (this.workshopRegistrationStateMutable.workshop_registrations[workshop.id]) {
          capacity -= this.workshopRegistrationStateMutable.workshop_registrations[workshop.id].count;
        }

        groupedWorkshops[parsedWorkshopHall].push({...workshop, capacity: capacity});

        return groupedWorkshops;
      }, {});

      return Object.keys(grouped)
        .sort()
        .reduce((a, c) => ((a[c] = grouped[c]), a), {});
    }
  },

  methods: {
    scrollToTheEnd() {
      this.$refs.workshops.scrollTo({left: this.$refs.workshops.scrollWidth, behavior: 'smooth'})
      this.scrolledToRight = true;
      this.offsetLeft = this.$refs.workshops.offsetLeft + 'px';
    },
    scrollToTheStart() {
      this.$refs.workshops.scrollTo({left: 0, behavior: 'smooth'})
      this.scrolledToRight = false;
    },
    clearSelectedArticle() {
      this.selectedProgramArticle = undefined;
      history.pushState(null, '', window.location.pathname);
    },
    selectPage(idx) {
      if (idx !== this.selected) {
        const prevSelected = this.selected;
        this.selected = idx;

        this.$nextTick(() => {
          const slides = this.$el.querySelectorAll('.transition-transform');
          slides.forEach((slide, index) => {
            if (index === prevSelected) {
              slide.classList.add(idx > prevSelected ? '-translate-x-full' : 'translate-x-full');
            }
          });
        });
      }
    },
    userHasWorkshopRegisteredForGivenTimeSlot(workshopStartTime) {
      for (const workshopForTimeSlot of this.workshopsGroupedByTime[workshopStartTime]) {
        for (const registeredWorkshopId of this.workshopRegistrationStateMutable.user_registrations) {
          if (workshopForTimeSlot.id === registeredWorkshopId) {
            return true;
          }
        }
      }

      return false;
    },

    async registerWorkshop(workshopId) {
      try {
        const res = await axios.post(
          `/api/workshop/${workshopId}/registration`,
          {}
        );
        this.workshopRegistrationStateMutable = res.data;
      } catch (err) {
      }
    },

    async unRegisterWorkshop(workshopId) {
      try {
        const res = await axios.delete(
          `/api/workshop/${workshopId}/registration`,
          {}
        );

        this.workshopRegistrationStateMutable = res.data;
      } catch (err) {
      }
    },

    selectProgramArticleAndAddToURL(article) {
      if(!article.capacity) {
        if (this.workshopRegistrationStateMutable.workshop_registrations[article.id]) {
          article.capacity = this.maxWorkshopRegistrationsPerUser - this.workshopRegistrationStateMutable.workshop_registrations[article.id].count
        } else {
          article.capacity = this.maxRegistrationsPerWorkshop
        }
      }
      this.selectedProgramArticle = article;

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('workshopId', article.id)

      const newRelativePathQuery = window.location.pathname + '?' + urlParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    },

    selectProgramArticle(article) {
      this.scrollToSection = false;
      this.selectProgramArticleAndAddToURL(article);
    },

    selectArticleIfPresentInSearchParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const workshopId = urlParams.get('workshopId');

      if (workshopId !== undefined) {
        this.programEvents.forEach((event) => {
          if (event.id === Number(workshopId)) {
            this.scrollToSection = true;
            this.selectProgramArticleAndAddToURL(event);
          }
        });
      }
    }
  },

  mounted() {
    this.selectArticleIfPresentInSearchParams();
  }
};
</script>

<style scoped>
.fadeRight-enter-active,
.fadeRight-leave-active {
  transition: opacity 0.3s ease;
}
.fadeRight-enter-from,
.fadeRight-leave-to {
  opacity: 0;
}
.fadeRight-enter-to,
.fadeRight-leave-from {
  opacity: 1;
}
.fadeLeft-enter-active,
.fadeLeft-leave-active {
  transition: opacity 0.3s ease;
}
.fadeLeft-enter-from,
.fadeLeft-leave-to {
  opacity: 0;
}
.fadeLeft-enter-to,
.fadeLeft-leave-from {
  opacity: 1;
}
</style>
